<template>
  <div>
    <!--查询条件-->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="formData" size="mini" label-width="90px">
        <div class="formItemBox">
          <el-form-item label="入库单号:">
            <el-input v-model="formData.instockNo" placeholder="请输入入库单号" ></el-input>
          </el-form-item>
          <el-form-item label="车辆号牌:">
            <el-input v-model="formData.instockPlateNumber" placeholder="请输入车号"></el-input>
          </el-form-item>
          <el-form-item label="一级货主:">
            <el-select filterable clearable placeholder="请选择一级货主" v-model="formData.primaryCustomerTaxId">
              <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber" >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select clearable filterable placeholder="请选择二级货主" v-model="formData.secondaryCustomerTaxId">
              <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择" filterable>
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select v-model="formData.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:">
            <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择" filterable>
              <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入库日期:" >
            <div style="display: flex;">
              <el-date-picker v-model="formData.instockDateStart" type="datetime"
                placeholder="选择入库日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              -
              <el-date-picker v-model="formData.instockDateEnd" placeholder="选择入库日期" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </div>
          </el-form-item>
        </div>
        <el-form-item style="padding-left: 10px;">
          <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP00BB00M" v-if="btnFlg[21]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP00BB00N" v-if="btnFlg[22]">重置</el-button>
          <el-button type="primary" size="mini" @click="daochu" btnCode="00cP00BB00O" v-if="btnFlg[23]">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--  表格  v-loading='tabLoading'-->

    <div class="table" :style="{ height: h }">
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%; margin-top: 10px"
        center
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }"
        :row-style="{ height: '35px' }"
        highlight-current-row
      >
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库日期" align="center" width="180" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" align="center" width="220" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" align="center" width="150" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center" width="220" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="secondaryCustomerName" label="二级货主" align="center" width="220" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="120" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="100" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="120" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="70" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="过磅净重时间" align="center" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center" width="120" ></el-table-column>
        <el-table-column prop="plateNumber" label="车船号" width="120" ></el-table-column>
        <el-table-column prop="shipForecastNo" label="预报编号" width="300" ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="110"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center" width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="删除人" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="删除时间" align="center" width="180"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.pageNo"
        :page-sizes="[10, 20, 30, 40,50]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  getRelationCustomer, // 字典客户
  getVirtualBalingList, // 货物类型、产地、规格、材质、长度、件数级联查询
  JfgetDeleteInStockExpList
} from '@/api/wms-stock.js'
import { exportExcel } from '@/utils/fileDown.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
import DonMessage from '@/utils/message'

export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnArr: [
        // 入库记录
        '00cP00BB001',
        '00cP00BB002',
        '00cP00BB003',
        '00cP00BB004',
        // 进仓记录
        '00cP00BB005',
        '00cP00BB006',
        '00cP00BB007',
        // 出库记录
        '00cP00BB008',
        '00cP00BB009',
        '00cP00BB00A',
        '00cP00BB00B',
        // 转货记录
        '00cP00BB00C',
        '00cP00BB00D',
        '00cP00BB00E',
        '00cP00BB00F',
        // 移库记录
        '00cP00BB00G',
        '00cP00BB00H',
        '00cP00BB00I',
        // 亏涨记录
        '00cP00BB00J',
        '00cP00BB00K',
        '00cP00BB00L',
        // 删除记录
        '00cP00BB00M',
        '00cP00BB00N',
        '00cP00BB00O',
        // 撤销记录
        '00cP00BB00P',
        '00cP00BB00Q',
        '00cP00BB00R',
        // 入库过磅记录
        '00cP00BB00S',
        '00cP00BB00T',
        '00cP00BB00U',
        '00cP00BB00V',
        '00cP00BB00W',
        '00cP00BB00X',
        // 出库过磅记录
        '00cP00BB00Y',
        '00cP00BB00Z',
        '00cP00BB00a',
        '00cP00BB00b',
        '00cP00BB00c',
        '00cP00BB00d'
      ],
      title: '',
      h: '500px',
      total: 0,
      formData: {
        instockNo: '',
        instockPlateNumber: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        primaryCustomerTaxId: '',
        secondaryCustomerTaxId: '',
        instockDateStart: '',
        instockDateEnd: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      customerData: [], // 货主数据
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      lengthData: [],
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      tableList: [],
      HZData: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/yycJiLuChaXun')
    this.getRelationCustomerS()
    this.JfgetDeleteInStockExpLists()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 202 + 'px'
  },
  methods: {
    // 列表查询
    JfgetDeleteInStockExpLists () {
      JfgetDeleteInStockExpList(
        {
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          instockNo: this.formData.instockNo,
          instockPlateNumber: this.formData.instockPlateNumber,
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          secondaryCustomerTaxId: this.formData.secondaryCustomerTaxId,
          productType: this.formData.productType,
          steelMillName: this.formData.steelMillName,
          specification: this.formData.specification,
          model: this.formData.model,
          instockDateStart: this.formData.instockDateStart,
          instockDateEnd: this.formData.instockDateEnd
        }
      )
        .then(res => {
          this.tableList = res.list
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxun () {
      this.JfgetDeleteInStockExpLists()
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.instockNo = ''
      this.formData.instockPlateNumber = ''
      this.formData.productType = ''
      this.formData.steelMillName = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.secondaryCustomerTaxId = ''
      this.formData.instockDateStart = ''
      this.formData.instockDateEnd = ''
      this.JfgetDeleteInStockExpLists()
      this.getVirtualBalingList()
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },

    // 每页条数
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetDeleteInStockExpLists()
    },
    // 当前页
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetDeleteInStockExpLists()
    },
    // 导出
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/stockExpInfo/exportDeleteInStockExpList',
        { ...this.formData, instockStatus: '1' },
        '删除记录信息表'
      )
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
      })
        .then((res) => {
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    }
  }
}
</script>
<style scoped lang='less'>
.inpBox{
  .el-form-item{
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
</style>
